import React, { useEffect, useState } from "react"
import { adapters, brands } from './info';
import { Input } from 'reactstrap';
import vickiImage from './assets/images/vicki.svg';
import compatibleVickiImage from './assets/images/compatible-vicki.svg';
import incompatibleVickiImage from './assets/images/incompatible-vicki.svg';

import logo from './assets/images/logo.svg';
import backArr from './assets/images/back-arrow.svg';

import Client from 'shopify-buy';

const client = Client.buildClient({
    storefrontAccessToken: '3277fcc755a53782a7b624a04b573193',
    domain: 'mclimate.myshopify.com'
});

const Home = () => {
    const [modifiedAdapters, setModifiedAdapters] = useState([]);
    const [adaptersArr, setAdaptersArr] = useState(adapters);

    const [modifiedBrands, setModifiedBrands] = useState([]);
    const [brandsArr, setBrandsArr] = useState(brands);

    const [valvesSelected, setValvesSelected] = useState(false);

    const [selectedValve, setSelectedValve] = useState(null);
    const [product, setProduct] = useState(null);
    const [vickiFromShopify, setVickiFromShopify] = useState(null);

    const tryRequire = (path) => {
        try {
            return require(`${path}`);
        } catch (err) {
            return null;
        }
    };

    useEffect(() => {
        getInitialAdaptersWithImages()
        fetchProductFromShopify("4597939241027", true)
    }, []);

    const getInitialAdaptersWithImages = () => {
        let wrongNames = [];
        let whatAdapter = [];
        let missingBrands = [];


        adapters.map((adapter, i) => {
            let name = (adapter.name).replaceAll(/\s/g, '');
            let brand = (adapter.Brand).replaceAll(/\s/g, '')
            let pathSvg = `./adapters/svgs/${brand}${(name)}.svg`;
            let pathPng = `./adapters/svgs/${brand}${(name)}.png`;
            let pathJpg = `./adapters/svgs/${brand}${(name)}.jpg`;

            if (!adapter.productId && adapter.compatibility === 'compatible') whatAdapter.push(`${brand}${(name)}`)
            if (tryRequire(pathSvg)) {
                return { ...adapter, ...adapter.imgname = pathSvg }
            } else if (tryRequire(pathPng)) {
                return { ...adapter, ...adapter.imgname = pathPng }
            } else if (tryRequire(pathJpg)) {
                return { ...adapter, ...adapter.imgname = pathJpg }
            } else {
                wrongNames.push(`${brand}${(name)}`)
                return { ...adapter, ...adapter.imgname = null }
            }

        })

        brands.map((brand, i) => {
            let pathPng = `./brands/${brand.name}.png`
            if (tryRequire(pathPng)) {
                return { ...brand, ...brand.imgname = pathPng }
            } else {
                missingBrands.push(brand)
                return { ...brand, ...brand.imgname = null }
            }
        })

        // console.log(wrongNames)
        setModifiedAdapters(adapters)
        setAdaptersArr(adapters)
        setBrandsArr(brands)
        setModifiedBrands(brands)
    }

    let compatible = selectedValve?.compatibility === 'compatible';

    const renderAdapters = () => {
        return modifiedAdapters.map((adapter, i) => {
            if (adapter.imgname) {
                return <div onClick={() => { setSelectedValve(adapter); fetchProductFromShopify(adapter.productId); }} className="a-block adater" key={`${i}-adapter`} >
                    <div className="valve-image" style={{ backgroundImage: `url(${require(`${adapter.imgname}`)})` }}></div>
                    <span>{adapter.name}</span>
                </div>
            }
            // else { return <p style={{width: '100%'}} key={`${i}-adapter-text`}>{adapter.Brand} {adapter.name} {adapter.imgname}</p> }
        })
    }

    const renderBrands = () => {
        return modifiedBrands.map((brand, i) => {
            if (brand.imgname) {
                return <div onClick={() => { brand.compatibility === 'valvesmodel' ? filterValvesByBrand(brand.name) : setSelectedValve({ 'compatibility': 'compatible' }) }} className="a-block brand" key={`${i}-brand`}
                    style={{ backgroundImage: `url(${require(`${brand.imgname}`)})` }}></div>
            }
            // else {
            //     return <p key={`${i}-brand-text`}>{brand.name}</p>
            // }
        })
    }

    const fetchProductFromShopify = (productId, vicki = null) => {
        // console.log(productId)
        return client.product.fetch(`gid://shopify/Product/${productId}`).then((res) => {
            let product = res;
            if (vicki) setVickiFromShopify(product)
            else setProduct(product);
            window.scrollTo(0, 0)
            return product
        }).catch(err => {
            console.log(err)
            window.scrollTo(0, 0)
            setProduct(null)
            return null
        });
    }

    // shopify-buy 2.x returns variants as an array with price as { amount, currencyCode }
    const formatPrice = (shopifyProduct) => {
        const price = shopifyProduct.variants[0]?.price;
        return price ? Number(price.amount ?? price).toFixed(2) : '';
    }

    const renderCompatibleValve = () => {
        if (product && vickiFromShopify) {
            return <div className="products-holder">
                <a className="product" target="_blank" href={vickiFromShopify.onlineStoreUrl}>
                    <img src={vickiFromShopify.images[0].src} />
                    <h2>{vickiFromShopify.title}</h2>
                    <p className="price">€{formatPrice(vickiFromShopify)} EUR incl. VAT</p>
                    <a target="_blank" className="btn main" href={vickiFromShopify.onlineStoreUrl}>Buy</a>
                </a>

                <a className="product" target="_blank" href={product.onlineStoreUrl}>
                    <img src={product.images[0].src} />
                    <h2>{product.title}</h2>
                    <p className="price">€{formatPrice(product)} EUR incl. VAT</p>
                    <a target="_blank" className="btn main" href={product.onlineStoreUrl}>Buy</a>
                </a>
            </div>
        }

        if (!product && vickiFromShopify && compatible) {
            return <div className="products-holder">
                <a className="product" target="_blank" href={vickiFromShopify.onlineStoreUrl}>
                    <img src={vickiFromShopify.images[0].src} />
                    <h2>{vickiFromShopify.title}</h2>
                    <p className="price">€{formatPrice(vickiFromShopify)} EUR incl. VAT</p>
                    <a target="_blank" className="btn main" href={vickiFromShopify.onlineStoreUrl}>Buy</a>
                </a>
            </div>
        }

        window.scrollTo(0, 0)

    }

    const searchFilter = (value, array) => {
        let lowerCaseValue = value.toLowerCase();
        if (valvesSelected) { setModifiedAdapters(array.filter(object => (((object.name).toLowerCase()).includes(lowerCaseValue)))) }
        else { setModifiedBrands(array.filter(object => ((object.name).toLowerCase()).includes(lowerCaseValue))) }
    }

    const filterValvesByBrand = (brand) => {
        setModifiedAdapters(adaptersArr.filter(object => ((object.Brand).toLowerCase()).includes(brand.toLowerCase())))
        setValvesSelected(true)
        window.scrollTo(0, 0)
    }

    const Tabs = () => {
        return (
            <div className="Tabs">
                {/* Tab nav */}
                <ul className="nav">
                    <li className={`${!valvesSelected && 'active'}`} onClick={() => { setValvesSelected(false); setSelectedValve(null) }}>Brand</li>
                    <li className={`${valvesSelected && 'active'}`} onClick={() => { setValvesSelected(true); getInitialAdaptersWithImages(); setSelectedValve(null) }}>Model</li>
                </ul>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="page-content">

                <div className="header">
                    <img src={logo} />

                    <div className="tabs-holder">
                        {Tabs()}
                        {/* <span className={`dot-tab ${valvesSelected && 'active'}`} onClick={() => { setValvesSelected(true); getInitialAdaptersWithImages(); setSelectedValve(null) }}></span>
                        <span className="tab-divider"></span>
                        <span className={`dot-tab ${!valvesSelected && 'active'}`} onClick={() => { setValvesSelected(false); setSelectedValve(null) }}></span> */}
                    </div>

                    <a className="btn main contact" target='_blank' href="https://mclimate.eu/pages/contacts">Contact</a>
                </div>


                <div className="head">
                    <img src={selectedValve ? compatible ? compatibleVickiImage : incompatibleVickiImage : vickiImage} />
                    <h2>{selectedValve
                        ? compatible ? 'Compatible' : 'Not compatible'
                        : 'TRV Compatibility tool'}</h2>
                    <p> {selectedValve
                        ? compatible ? 'Your installation is compatible with Vicki LoRaWAN smart thermostatic valve'
                            : `Your installation is not compatible with Vicki LoRaWAN smart thermostatic valve`
                        : `Select your thermostatic valve ${valvesSelected ? 'model' : 'brand'}`} </p>

                    {selectedValve && product
                        ? <p> {compatible && `Your installation requires `}<b>{product.title}</b></p>
                        : selectedValve && !product && <p> {compatible && `No adapters required`}</p>
                    }

                    <p className="disclaimer">
                        For guidance only, not an exhaustive or guaranteed list. Thread sizes can vary by valve age and series; please check the valve thread (M30×1.5) before ordering, or <a target='_blank' href="https://mclimate.eu/pages/contacts">contact us</a>.
                    </p>

                </div>

                {!selectedValve &&
                    <div className="search-field">
                        <Input onChange={(e) => { searchFilter(e.target.value, valvesSelected ? adaptersArr : brandsArr) }} placeholder={`Search for a static thermostat ${valvesSelected ? 'model' : 'brand'}...`} />
                    </div>
                }

                <div className="adapters-holder">
                    {selectedValve
                        ? renderCompatibleValve()
                        : valvesSelected ? renderAdapters() : renderBrands()
                    }

                    {selectedValve &&
                        <div onClick={() => { setSelectedValve(null); getInitialAdaptersWithImages(); }} className="btn border">
                            <img src={backArr} /> Back to valve models
                        </div>}
                </div>
            </div>


            {/* <footer className="main-footer">
                <div className="footer-row footer-columns clearfix footer-shrink">
                    <div className="bottom-footer-row-wrapper">
                        <div className="footer-row footer-columns clearfix footer-row-bottom">

                            <div className="footer-column footer-menu logo-menu" style={{ marginRight: "10%" }}>
                                <img src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/mclimate-logo-footer.svg?v=32954462808082457811660217874/" />
                                <p className="footer-copyright">
                                    © {new Date().getFullYear()}. All rights reserved.
                                </p>
                            </div>

                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">About MClimate</h4>
                                <ul className="footer-menu-list">
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/about-us">About us</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/blogs/blog">Blog</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/investors">Investors</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/careers">Careers</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/terms">Terms and conditions</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/payment-terms">Payment terms</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/privacy-policy">Privacy policy</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/contacts">Contact us</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/media-kit">Media kits</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Support</h4>
                                <ul className="footer-menu-list">
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://seemelissa.zendesk.com/hc/en-us" target="_blank">Help desk (FAQ)</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://seemelissa.zendesk.com/hc/en-us/requests/new" target="_blank">Submit a ticket</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/developers">Developers</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Business</h4>
                                <ul className="footer-menu-list">
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/smartbuildings">Smart buildings</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/utilities">Utilities</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/mcore">MCore</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/distributors">Partnerships</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/lorawan-resources">LoRaWAN Resources</a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/enterprise">MClimate Enterprise</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="footer-column footer-menu social-menu">
                                <h4 className="footer-title footer-menu-title">Social</h4>
                                <ul className="footer-menu-list">
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://www.facebook.com/MClimate" target="_blank">
                                            <img style={{ marginRight: "5px", width: "15px", height: "15px" }} src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/Facebook.svg?v=174175073062969142111660218326/" />
                                            Facebook
                                        </a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://twitter.com/MClimate_" target="_blank">
                                            <img style={{ marginRight: "5px", width: "15px", height: "15px" }} src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/Twitter.svg?v=60045844745023995211660218313/" />
                                            Twitter
                                        </a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://www.instagram.com/mclimate/" target="_blank">
                                            <img style={{ marginRight: "5px", width: "15px", height: "15px" }} src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/Instagram.svg?v=129512570591303475821660218332/" />
                                            Instagram
                                        </a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://www.linkedin.com/company/mclimate/" target="_blank">
                                            <img style={{ marginRight: "5px", width: "15px", height: "15px" }} src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/LinkedIn.svg?v=5013984139899447731660218343/" />
                                            LinkedIn
                                        </a>
                                    </li>
                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://www.youtube.com/channel/UCtRfSPGU0MLo_cRPGz_p2Rg" target="_blank">
                                            <img style={{ marginRight: "5px", width: "15px", height: "15px" }} src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/YouTube.svg?v=7976100472276691561660218319/" />
                                            YouTube
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="lorawan-partner footer-row-bottom">
                            <img style={{ width: "300px" }} src="//cdn.shopify.com/s/files/1/0043/8874/9379/t/5/assets/eit-logo.png?v=99016244673010216701658486836/" />
                            <div className="footer-column footer-content" style={{ padding: 0 }}>
                                <h4 className="footer-title footer-menu-title">
                                    We accept payment via
                                </h4>
                                <div className="footer-menu-text">
                                    <img src="https://cdn.shopify.com/s/files/1/0043/8874/9379/files/payment.png?v=1614342782" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer> */}

            <footer className="main-footer">
                <div className="footer-row footer-columns clearfix footer-shrink">

                    <div className="bottom-footer-row-wrapper">
                        <div className="footer-row footer-columns clearfix footer-row-bottom">
                            <div className="footer-column footer-menu logo-menu" style={{ marginRight: "10%" }}>
                                <img src="//mclimate.eu/cdn/shop/t/5/assets/mclimate-logo-footer.svg?v=4343393978580569991702547753/" />
                                <p className="footer-copyright">

                                    © {new Date().getFullYear()}. All rights reserved.
                                </p>
                                <div className="social-icons-footer-1" style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "flex-start",
                                    gap: "4px",
                                }}>
                                    <a href="https://www.linkedin.com/company/mclimate/" target="_blank">
                                        <img src="//mclimate.eu/cdn/shop/t/5/assets/LinkedIn-new.svg?v=72217560530371768121702390657/" />
                                    </a>

                                    <a href="https://www.youtube.com/channel/UCtRfSPGU0MLo_cRPGz_p2Rg" target="_blank">
                                        <img src="//mclimate.eu/cdn/shop/t/5/assets/YouTube-new.svg?v=19510765868620142791702390637/" />
                                    </a>
                                </div>
                            </div>


                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Solutions</h4>
                                <ul className="footer-menu-list">

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/smart-buildings-heating">Indoor Climate Optimisation</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/smart-buildings-aqi">Air Quality and CO2 Monitoring</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/smart-buildings-water-control">Water Control</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/enterprise">MClimate Enterprise</a>
                                    </li>

                                </ul>
                            </div>


                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Resources</h4>
                                <ul className="footer-menu-list">

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/about-lorawan">What is LoRaWAN</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/smartbuildings">Smart Buildings</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/case-studies">Case Studies</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/lorawan-resources">LoRaWAN Technical Resources</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/payload-helper">LoRaWAN Payload Helper</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/lorawan-battery-calculator">LoRaWAN Battery Calculator</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/bms">Integration with BMSs</a>
                                    </li>

                                </ul>
                            </div>


                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Support</h4>
                                <ul className="footer-menu-list">

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/developers">API Documentation</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/media-kit">Media kits</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/lorawan-resources">Help desk (FAQ)</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://status.mclimate.eu/">Services status</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/contacts">Contact us</a>
                                    </li>

                                </ul>
                            </div>


                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Company</h4>
                                <ul className="footer-menu-list">

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/about-us">About us</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/partners">Partnership</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/careers">Careers</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="/blogs/blog">Blog</a>
                                    </li>

                                </ul>
                            </div>


                            <div className="footer-column footer-menu">
                                <h4 className="footer-title footer-menu-title">Legal</h4>
                                <ul className="footer-menu-list">

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/terms">Terms and Conditions</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/sla">Service Level Agreement</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/payment-terms">Payment terms</a>
                                    </li>

                                    <li className="footer-menu-list-item">
                                        <a className="footer-menu-list-item-anchor" href="https://mclimate.eu/pages/privacy-policy">Privacy policy</a>
                                    </li>

                                </ul>
                            </div>


                        </div>
                    </div>

                </div>
            </footer>


        </React.Fragment>
    )
}


export default Home